// extracted by mini-css-extract-plugin
module.exports = {"CalendarDescriptionDay":"index-shimmer_CalendarDescriptionDay__2heCP","placeholderShimmer":"index-shimmer_placeholderShimmer__1kRg_"};